module.exports = __webpack_public_path__ + "img/ex.8649024f.png";